import { HttpEffects } from './http.effect';

export const CoreEffects = [HttpEffects];

export * from './http.effect';
